import { render, staticRenderFns } from "./addFile.vue?vue&type=template&id=08b15f70&scoped=true"
import script from "./addFile.vue?vue&type=script&lang=js"
export * from "./addFile.vue?vue&type=script&lang=js"
import style0 from "./addFile.vue?vue&type=style&index=0&id=08b15f70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b15f70",
  null
  
)

export default component.exports